import React from "react";

interface Card {
  id: number;
  no: string;
  title: string;
  text: string;
}

const cardsData: Card[] = [
  {
    id: 1,
    title: "Crypto - Fiat Conversion",
    text: "Convert cryptocurrencies to Fiat currencies or Fiat currencies to the crypto of your preference in a fast and secure environment.",
    no: "01",
  },
  {
    id: 2,
    title: "OTC Desk Services",
    text: "We offer B2B/B2C VIP clients special conversion conditions depending on the size of the requested transaction giving you tailor made solutions.",
    no: "02",
  },
  {
    id: 3,
    title: "Liquidity Provider",
    text: "We specialise in liquidity provision, offering seamless integration via API for real-time pricing on fintech platforms. With us, you gain access to dynamic trade execution support, ensuring optimal transaction outcomes.",
    no: "03",
  }
];

const CardSlideshowMB: React.FC = () => {


  return (
    <div className="slideshow-container flex flex-col justify-start overflow-x-hidden w-[100%]">
      <div
        className="flex transition-transform duration-300 flex-col gap-4 justify-center items-center pb-[3rem]"
      >
        {cardsData.map((card, ) => {
          // Aplica clase diferite pentru cardul curent
          return (
            <div
              key={card.id}
              className="cardSlideShow w-[90%] mx-[0.25rem] transition-colors duration-300 bg-[#222B45] text-[#FFF]"
              
            >
              <div className="cardSlideShow__no">{card.no}</div>
              <div className="cardSlideShow__title">{card.title}</div>
              <div className="cardSlideShow__text">{card.text}</div>
            </div>
          );
        })}
      </div>
      
    </div>
  );
};

export default CardSlideshowMB;
